import React from "react";
import "./About.css";
import InsideSacredWalls from "../../component/comman/insideSacredWalls/InsideSacredWalls";
import "./AboutMedia.css";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const About = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    AOS.init({ duration: 1000, once: true, easing: "ease-in-out" });
  }, []);
  return (
    <div className="about-container">
      <section className="about-section" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">
          A <span>Sacred Haven</span> of Devotion and Spiritual Enlightenment
        </h1>
        <div className="about-flex">
          <p data-aos="fade-right" data-aos-delay="200">
            Nestled in the heart of{" "}
            <span style={{ color: "#ab0000" }}>Katchanagaram</span>, Tamil Nadu,
            <span style={{ color: "#ab0000" }}>Adhie Annan Temple</span> is a
            divine sanctuary where faith, culture, and spirituality blend
            harmoniously. With its rich history, magnificent architecture, and
            vibrant religious activities, our temple has been a source of solace
            and guidance for devotees across generations. Whether you seek
            blessings, peace of mind, or spiritual awakening, our doors are
            always open to all.
            <span className="hidden">
              The temple is not only a spiritual haven but also a cultural
              epicenter where festivals like Panguni Uthiram, Aadi Thiruvizha,
              and Karthigai Deepam are celebrated with great fervor.
            </span>
            <br />
            தமிழ்நாட்டின் கட்சநகரத்தின் மையப்பகுதியில் அமைந்துள்ள ஆதி அண்ணன்
            கோயில், நம்பிக்கை, கலாச்சாரம் மற்றும் ஆன்மீகம் ஆகியவை இணக்கமாக கலந்த
            ஒரு தெய்வீக சரணாலயமாகும். அதன் வளமான வரலாறு, அற்புதமான கட்டிடக்கலை
            மற்றும் துடிப்பான மத நடவடிக்கைகளால், எங்கள் கோயில் தலைமுறை
            தலைமுறையாக பக்தர்களுக்கு ஆறுதல் மற்றும் வழிகாட்டுதலின் ஆதாரமாக
            இருந்து வருகிறது. நீங்கள் ஆசிர்வாதம், மன அமைதி அல்லது ஆன்மீக
            விழிப்புணர்வைத் தேடினாலும், எங்கள் கதவுகள் எப்போதும் அனைவருக்கும்
            திறந்திருக்கும்.
            <span className="hidden">
              இந்த கோயில் ஒரு ஆன்மீக புகலிடம் மட்டுமல்ல, பங்குனி உத்திரம், ஆடி
              திருவிழா மற்றும் கார்த்திகை தீபம் போன்ற பண்டிகைகள் மிகுந்த
              உற்சாகத்துடன் கொண்டாடப்படும் ஒரு கலாச்சார மையமாகும்.
            </span>
          </p>
          <img
            data-aos="zoom-in"
            data-aos-delay="300"
            src="/assets/image/about-img/about-1.svg"
            alt="Temple"
          />
        </div>
      </section>

      <section className="about-section" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">
          Our Glorious <span>History & Legacy</span>
        </h1>
        <div className="about1-flex about-flex">
          <p data-aos="fade-left" data-aos-delay="200">
            The origins of Adhie Annan Temple date back to 1999, when it was
            established as a humble place of worship. Over the years, it has
            evolved into a grand spiritual hub, deeply revered for its religious
            significance and deep-rooted traditions. According to legend, Lorem
            ipsum dolor sit amet consectetur. Orci accumsan egestas diam et
            pellentesque tincidunt nulla integer consectetur. What began as a
            modest shrine has now grown into a spiritual beacon, attracting
            pilgrims not only from the surrounding regions but from across Tamil
            Nadu.
            <span className="hidden">
              The temple premises have expanded to include meditation halls, a
              community dining space, and ritual zones designed for major
              spiritual events. Every brick and carving reflects the collective
              efforts of volunteers, artisans, and devotees who have poured
              their hearts into shaping this sacred site.Annual kumbhabhishekam
              ceremonies, special poojas, and festival.
            </span>
            <br />
            ஆதி அன்னான் கோயிலின் தோற்றம் 1999 ஆம் ஆண்டுக்கு முந்தையது, அப்போது
            அது ஒரு எளிய வழிபாட்டுத் தலமாக நிறுவப்பட்டது. பல ஆண்டுகளாக, இது ஒரு
            பெரிய ஆன்மீக மையமாக பரிணமித்துள்ளது, அதன் மத முக்கியத்துவம் மற்றும்
            ஆழமான வேரூன்றிய மரபுகளுக்காக ஆழமாக மதிக்கப்படுகிறது. புராணத்தின்
            படி, லோரெம் இப்சம் டோலர் சிட் அமெட் கான்செக்டெட்டர். ஓர்சி
            அக்யூம்சன் எஜெஸ்டாஸ் டைம் எட் பெல்லன்டெஸ்க்யூ டிஞ்சிடுண்ட் நுல்லா
            இன்டெஜர் கான்செக்டெட்டர். ஒரு சாதாரண ஆலயமாகத் தொடங்கியது இப்போது ஒரு
            ஆன்மீக கலங்கரை விளக்கமாக வளர்ந்துள்ளது, சுற்றியுள்ள பகுதிகளிலிருந்து
            மட்டுமல்ல, தமிழ்நாடு முழுவதிலுமிருந்து யாத்ரீகர்களை ஈர்க்கிறது.
            <span className="hidden">
              கோயில் வளாகம் தியான மண்டபங்கள், ஒரு சமூக உணவருந்தும் இடம் மற்றும்
              முக்கிய ஆன்மீக நிகழ்வுகளுக்காக வடிவமைக்கப்பட்ட சடங்கு மண்டலங்கள்
              என விரிவடைந்துள்ளது. ஒவ்வொரு செங்கல் மற்றும் செதுக்கலும் இந்த
              புனித தலத்தை வடிவமைப்பதில் தங்கள் இதயங்களை ஊற்றிய தன்னார்வலர்கள்,
              கைவினைஞர்கள் மற்றும் பக்தர்களின் கூட்டு முயற்சிகளை
              பிரதிபலிக்கிறது.
            </span>
          </p>
          <img
            data-aos="zoom-in"
            data-aos-delay="300"
            src="/assets/image/about-img/about-2.svg"
            alt="History"
          />
        </div>
      </section>
      <section className="about-section" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">
          <span>Our Deity</span> & Spiritual Significance
        </h1>
        <div className="about-flex">
          <div
            className="deity-text"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <p>
              At the heart of our temple lies the presiding deity, Adhie Annan,
              worshipped as the embodiment of Virtue, Power, Wisdom, Prosperity,
              Health, and Protection.
              <br />
              எங்கள் கோவிலின் மையத்தில் தலைமை தெய்வமான ஆதி அன்னன் உள்ளார், அவர்
              நல்லொழுக்கம் அல்லது சக்தி, ஞானம், செழிப்பு, ஆரோக்கியம், பாதுகாப்பு
              ஆகியவற்றின் உருவகமாக வணங்கப்படுகிறார்.
            </p>
            <p>Other significant shrines within the temple include:</p>
            <div className="sub-deities">
              <div>
                <div
                  className="sub-deities-flex"
                  data-aos="fade-left"
                  data-aos-delay="100"
                >
                  <span>Murugan</span>
                  <p>-</p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Orci accumsan gestas
                    diam et pellentesque tincidunt nulla integer.
                    <br />
                    {/* லோரெம் இப்சம் டோலர் சிட் அமெட் கான்செக்டேர். Orci accumsan
                    gestas diam et pellentesque tincidunt nulla integer. */}
                  </p>
                </div>
                <div
                  className="sub-deities-flex"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <span>Shiva</span>
                  <p>-</p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Orci accumsan gestas
                    diam et pellentesque tincidunt nulla integer.
                    <br />
                    {/* லோரெம் இப்சம் டோலர் சிட் அமெட் கான்செக்டேர். Orci accumsan
                    gestas diam et pellentesque tincidunt nulla integer. */}
                  </p>
                </div>
                <div
                  className="sub-deities-flex"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <span>Ayyappan</span>
                  <p>-</p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Orci accumsan gestas
                    diam et pellentesque tincidunt nulla integer.
                    <br />
                    {/* லோரெம் இப்சம் டோலர் சிட் அமெட் கான்செக்டேர். Orci accumsan
                    gestas diam et pellentesque tincidunt nulla integer. */}
                  </p>
                </div>
              </div>
              <p data-aos="fade-up" data-aos-delay="400">
                Each day, the temple resonates with the sounds of vedic chants,
                ringing bells, and devotional hymns, creating a spiritually
                uplifting atmosphere for every visitor.
                <br />
                ஒவ்வொரு நாளும், கோயில் வேத மந்திரங்கள், மணிகள் ஓசைகள் மற்றும்
                பக்தி பாடல்களின் ஒலிகளால் எதிரொலிக்கிறது, ஒவ்வொரு
                பார்வையாளருக்கும் ஆன்மீக उत्तावनावन சூழலை உருவாக்குகிறது.
              </p>
            </div>
          </div>
          <img
            data-aos="zoom-in"
            data-aos-delay="300"
            src="/assets/image/about-img/about-3.svg"
            alt="Deities"
          />
        </div>
      </section>
      <div data-aos="fade-up" data-aos-delay="200">
        <InsideSacredWalls />
      </div>
    </div>
  );
};
